<template>
<div class="chapter">
<div class="inner_page">
<div class="copy">
<p class="nonindent"><strong>Front cover: main image – Darwin Wiggett; bottom row, from left to right:</strong></p>
<p class="nonindent"><strong>Tom Mackie, William Neill, David Noton, Tony Worobiec</strong></p>
<p class="nonindent"><strong>Back cover: David Noton</strong></p>
<p class="nonindent12">A DAVID &amp; CHARLES BOOK</p>
<p class="nonindent">Copyright © David &amp; Charles Limited 2008</p>
<p class="extract">David &amp; Charles is an F+W Publications Inc. company</p>
<p class="nonindent">4700 East Galbraith Road</p>
<p class="nonindent">Cincinnati, OH 45236</p>
<p class="extract">First published in the UK in 2008</p>
<p class="extract">Text and photographs copyright © Tom Mackie, William Neill, David Noton, <br/>Darwin Wiggett and Tony Worobiec 2008</p>
<p class="extract">Tom Mackie, William Neill, David Noton, Darwin Wiggett and Tony Worobiec have asserted their right to be identified as authors of this work in accordance with the Copyright, Designs and Patents Act, 1988.</p>
<p class="extract">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted, in any form or by any means, electronic or mechanical, by photocopying, recording or otherwise, without prior permission in writing from the publisher.</p>
<p class="extract">A catalogue record for this book is available from the British Library.</p>
<p class="extract">ISBN-13: 978-0-7153-2936-8 hardback</p>
<p class="nonindent">ISBN-10: 0-7153-2936-7 hardback</p>
<p class="extract">ISBN-13: 978-0-7153-2940-5 paperback</p>
<p class="nonindent">ISBN-10: 0-7153-2940-5 paperback</p>
<p class="extract">Printed in China by SNP Leefung</p>
<p class="nonindent">for David &amp; Charles</p>
<p class="nonindent">Brunel House Newton Abbot Devon</p>
<p class="extract">Commissioning Editor: Neil Baber</p>
<p class="nonindent">Desk Editor: Emily Rae</p>
<p class="nonindent">Project Editor: Cathy Joseph</p>
<p class="nonindent">Copy Editor: Nicola Hodgson</p>
<p class="nonindent">Designer: Joanna Ley</p>
<p class="nonindent">Production Controller: Beverley Richardson</p>
<p class="extract">Visit our website at <a href="http://www.davidandcharles.co.uk" target="_blank">www.davidandcharles.co.uk</a></p>
<p class="extract">David &amp; Charles books are available from all good bookshops; alternatively you<br/>can contact our Orderline on 0870 9908222 or write to us at FREEPOST EX2 110, <br/>D&amp;C Direct, Newton Abbot, TQ12 4ZZ (no stamp required UK only); US customers <br/>call 800-289-0963 and Canadian customers call 800-840-5220.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781446352496_epub_cop.vue?1b204a18